import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, Platform } from '@ionic/angular';
import { Router, Route } from '@angular/router';
import { Location, PlatformLocation } from '@angular/common';
import { HostListener } from '@angular/core';
import { NetworkServicesService } from '@app/_services/network-services.service';
import { AppConsts } from '@shared/AppConsts';
import { Globals } from '../globals';
import { StringUtils } from '@shared/utils/StringUtils';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html'
})
export class BaseComponent implements OnInit {
  backButtonSubscription: any;
  alert: any;
  static alertCu: any;
  constructor(private platform: Platform,
    private router: Router,
    private _location: Location,
    private alertCtrl: AlertController,
    private location: PlatformLocation,
    public networkService: NetworkServicesService,
    public globals: Globals,
    private navCtrl: NavController
  ) {
   
  }
  getRouteLenght(config: Route[]): boolean{
    console.log('test');
    console.log(config);
    if(config.length == 1){
      return true;
    }
    else {
      return false;
    }
  }
  ngOnInit(): void {
    if (StringUtils.isMobilePlatform(this.platform) && this.platform.is('android')) {
  
    // navigator['app'].clearHistory();
  
    // this.location.pushState('myInitialState', null, null);
    this.location.onPopState(async () => {
      console.log('pressed back base!');
      
      if (this.platform.is('android') ) {
        console.log('pressed back button');
        console.log('router url:' + this.router.url);
        console.log('histrory'+ window.history);
        
        if (this.router.isActive('/credit-union-list', true) && this.router.url === '/credit-union-list') {
          
          this.location.pushState('myInitialState', null, null);
          console.log('isActive:' + this.router.url);
          // navigator['app'].clearHistory();
          
          if(BaseComponent.alertCu == null) {
            if(this.alert != null) {
              // this.location.back();
              this.alert.dismiss();
              this.alert = null;
            } else {
           
              this.alert = await this.alertCtrl.create({
                header: 'Exit the app',
                message: 'Do you want to exit the app?',
                backdropDismiss: false,
                cssClass: 'alertCustomCss',
                buttons: [
                  {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                      // this.location.back();
                      this.alert = null;
                    }
                  }, {
                    text: 'Exit',
                    handler: () => {
                      this.alert.dismiss();
                      navigator['app'].exitApp();
                    }
                  }
                ]
              });
              await this.alert.present();
            }
            
          } else {
            BaseComponent.alertCu.dismiss();
            BaseComponent.alertCu = null;
          }
 
        } 
        // else if (this.router.isActive('/credit-union', true) && this.router.url === '/credit-union'){
        //   console.log('will naviagte to credit-union-list');
        //   // if(this.platform.is('android') && !this.platform.is('mobileweb')){
        //   //   window.localStorage.setItem('clearHistory', '1');
        //   //  }
        //   //  this._location.back();
        //   //  this.router.navigate(['credit-union-list']);
        //   if(this.platform.is('android') && !this.platform.is('mobileweb')){
        //     window.localStorage.setItem('clearHistory', '1');
        //    }
        //   this.router.navigate(['./credit-union-list']);
        // }
       
        else if (this.router.isActive('/credit-union/yourloans', true) && this.router.url === '/credit-union/yourloans'){
          console.log('current page yourloans');
          if (window.localStorage.getItem("backAfterApplyLoan") != null && window.localStorage.getItem("backAfterApplyLoan") == '1') {
            window.localStorage.removeItem('backAfterApplyLoan');
            this.location.back();
            this.router.navigate(['./credit-union']);
          }
         
        } else if (this.router.isActive('/more/bank-details/list', true) && this.router.url === '/more/bank-details/list'){
          // alert("test");
          console.log('current page bank details list');
          if (window.localStorage.getItem("backAfterAddBankDetial") != null && window.localStorage.getItem("backAfterAddBankDetial") == '1') {
            window.localStorage.removeItem('backAfterAddBankDetial');
            this.location.back();
            this.router.navigate(['./more']);
          } else {
            this.router.navigate(['./more']);
          }
         
        } else if (this.router.isActive('/more/mno-details/list-mno', true) && this.router.url === '/more/mno-details/list-mno'){
          // alert("test");
          console.log('current page mno details list');
          if (window.localStorage.getItem("backAfterAddMnoDetial") != null && window.localStorage.getItem("backAfterAddMnoDetial") == '1') {
            window.localStorage.removeItem('backAfterAddMnoDetial');
            this.location.back();
            this.router.navigate(['./more']);
          } else {
            this.router.navigate(['./more']);
          }
         
        }
       
      }
    });
    }
    if(StringUtils.isMobilePlatform(this.platform)){
      
      console.log('No internet : mobile platform');
      if (this.networkService.refresh$.subscribe(() => this.refresh())) {
        console.log('internet connection available');
        this.globals.showNoInternet = false;
        this.globals.showData = true;
      } else {
        console.log('no internet connection');
        this.globals.showNoInternet = true;
        this.globals.showData = false;
      }
    } else {
      this.globals.showNoInternet = false;
      this.globals.showData = true;
    }
    console.log('ngOnInit base');
   
  }
  private refresh() {
    // refresh your page (what you want to refresh)
    // Example
    console.log('refresh : On internet connection');
    this.globals.showNoInternet = false;
    this.globals.showData = true;
  }
  // @HostListener('window:popstate', ['$event'])
  // async onPopState(event) {
  //   console.log('Back button pressed');
  //   if(this.platform.is('mobile')){
  //     console.log('pressed back button');
  //     console.log('router url:' + this.router.url);
  //     if (this.router.isActive('/credit-union-list', true) && this.router.url === '/credit-union-list') {
  //       console.log('isActive:' + this.router.url);
  //       const alert = await this.alertCtrl.create({
  //         header: 'Exit the app',
  //         message: 'Do you want to exit the app?',
  //         buttons: [
  //           {
  //             text: 'Cancel',
  //             role: 'cancel'
  //           }, {
  //             text: 'Exit',
  //             handler: () => {
  //               alert.dismiss();
  //               navigator['app'].exitApp();
  //             }
  //           }
  //         ]
  //       });
  //       await alert.present();
  //     }
  //   }
  // }
}
